//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
const API_BASE_URL = 'https://hupu74nm0e.execute-api.us-east-1.amazonaws.com';

export const sendChatMessage = async (message, conversationId = null) => {
  try {
    // Prepare the payload exactly as shown in your examples
    const payload = {
      message: message
    };
    
    // Add conversationId only if it exists (for subsequent messages)
    if (conversationId) {
      payload.conversationId = conversationId;
    }
    
    const response = await fetch(`${API_BASE_URL}/api/query`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to send message');
    }

    return await response.json();
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};


export const checkHealth = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/health`);
    return await response.json();
  } catch (error) {
    console.error('Health check error:', error);
    throw error;
  }
};

export const sendChatMessageMock = async (payload) => {
    // Mock response for testing
    console.log("Would have sent payload:", payload);
    
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Return mock data
    return {
      reply: "This is a mock response,the bedrock model was disabled and available on request",
      sources: []
    };
  };